import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import { AuthService } from '../services/auth.service'; 
import {Router} from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ToastrService } from 'ngx-toastr';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private toastr: ToastrService,private ngxService: NgxUiLoaderService, private router: Router) {}
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.ngxService.stop('');
    return next.handle(request).pipe(
      map((response: any) => {
        if (response.ok && response.status === 200){
          if (!response.body){
            return throwError(response);
          }
        }
        return response;
      }),
      catchError(err => {
      this.ngxService.stop();
      if (err.status === 401) {
        this.toastr.clear();
        this.router.navigate(['login', {}]);
      } else if (err.status === 403) {
        this.toastr.clear();
        $(".body-container").addClass("sinpermisos");
      }
      return throwError(err);
    }));
  }
}
